import { useRouter } from 'next/router';

import RefreshCategory from '~/src/common/components/RefreshCategory';
import { SeoHome } from '~/src/common/components/Seo/SeoHome';
import { useOnSitePickupSlot } from '~/src/common/hooks/useOnSitePickupSlot';
import I18n from '~/src/common/services/I18n';
import { useGetCategory, useNavigation } from '~/src/queries/api-ecom/generated/api-ecom';
import HomeScreenFooter from '~/src/screens/Home/HomeScreenFooter';
import HomeScreenHeader from '~/src/screens/Home/HomeScreenHeader';
import useAccountManagementModal from '~/src/screens/Home/hooks/useAccountManagementModal';
import useHomeNotifications from '~/src/screens/Home/hooks/useHomeNotifications';
import useOpenCartModal from '~/src/screens/Home/hooks/useOpenCartModal';
import HomeSkeleton from '~/src/screens/Home/Skeleton/HomeSkeleton';
import { NextPage } from '~/src/typings/next';

import HomeScreenContent from './HomeScreenContent';
import { HomeTrustpilot } from './HomeTrustpilot/HomeTrustpilot';

const HomeScreen: NextPage = () => {
  const { data: navigationData } = useNavigation();

  const {
    data: homeCategory,
    refetch,
    isError,
  } = useGetCategory(navigationData?.home.slug ?? '', {
    query: {
      enabled: navigationData?.home.slug !== undefined,
    },
  });

  useAccountManagementModal();

  const openCartModal = useOpenCartModal();
  useHomeNotifications(openCartModal);

  const { replace, pathname } = useRouter<{
    login?: boolean;
    signup?: boolean;
    ordercancelled?: string;
    iscartopen?: string;
  }>();

  // si on arrive avec une URL de PDR sur place
  useOnSitePickupSlot({
    // redirect home et clean les params
    onSuccess: () => {
      void replace(pathname, undefined, { shallow: true, scroll: false });
    },
  });

  const headersIds =
    homeCategory?.items
      .filter(i => i.type === 'CUSTOM_CONTENT' && i.customContentType === 'Header')
      .map(i => i.id) ?? [];

  return (
    <>
      <SeoHome
        metaDescription={homeCategory?.metaDescription}
        metaTitle={homeCategory?.metaTitle}
        metaCanonical={homeCategory?.metaCanonical}
        noIndex={homeCategory?.noIndex}
        image={homeCategory?.image}
      />
      <div>
        <HomeScreenHeader title={homeCategory?.title ?? I18n.t('home.category-name')} />
        {isError ? <RefreshCategory onButtonClick={() => void refetch()} /> : null}
        {!isError && homeCategory == null ? <HomeSkeleton /> : null}
        <HomeScreenContent subCategories={homeCategory?.subcategories} headersIds={headersIds} />
        <HomeTrustpilot />
        <HomeScreenFooter footer={homeCategory?.footer} />
      </div>
    </>
  );
};

export default HomeScreen;
